module["exports"] = [
  "Việt Nam"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/vi/address/default_country.js
 ** module id = 1083
 ** module chunks = 0
 **/